var utils = require('../../utils')
import AppHeader from '../AppHeader'

//
// 入社手続き 対象者一覧（F-NEW-01 / F-NEW-05）
//
export default {
  name: 'onboarding-list',
  created () {
    if (!this.canReview) {
      this.$router.push({ path: '/' })
      return
    }
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false
    }
  },
  computed: {
    users () {
      return this.$store.getters.onboardingUsers
    },
    notify () {
      return this.$store.getters.onboardingNotify
    },
    forbidden () {
      return this.$store.getters.onboardingForbidden
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    // 社員一覧と同じタブバーを出すための判定（user-list.js と同じ getter）
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isBrowsIncluding () {
      return this.$store.getters.isBrowsIncluding
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isClerk () {
      return this.$store.getters.clerk
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    isHrManager () {
      return window.localStorage.getItem('user_authority') === '5'
    },
    // 一覧・確認ができるか（権限区分2・3、店舗管理者・事務員は自店、総務系は全店）
    canReview () {
      return this.canRegister
    },
    // 仮登録できるのは本社採用担当（人事担当・人事管理責任者・システム管理者）と、
    // 権限区分が店舗管理者以上（2）・自店入力者（3）の人（自店のみ）。店舗管理者フラグ・事務員も引き続き可
    canRegister () {
      return this.isSystemManagement || this.isHrManager || this.isHumanStaff ||
        this.isAppIncluding || this.isAppNotIncluded || this.isShopMaster || this.isClerk
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goUserLists: function () {
      utils.backClear()
      this.$router.push({path: '/users', query: {type: this.$router.currentRoute.query.type}})
    },
    goPhotoLists: function () {
      utils.backClear()
      this.$router.push({path: '/userphotos', query: {type: this.$router.currentRoute.query.type}})
    },
    goChangeLists: function () {
      utils.backClear()
      this.$router.push({path: '/userchanges', query: {type: this.$router.currentRoute.query.type}})
    },
    goShopLists: function () {
      utils.backClear()
      this.$router.push({path: '/shops', query: {type: this.$router.currentRoute.query.type}})
    },
    goRitireeLists: function () {
      utils.backClear()
      this.$router.push({path: '/retiree', query: {type: this.$router.currentRoute.query.type}})
    },
    search: function () {
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('GET_ONBOARDING_USERS', {callback: callback})
    },
    statusClass: function (status) {
      if (status === 'onboarding_temporary') return 'label-default'
      if (status === 'onboarding_submitting') return 'label-warning'
      if (status === 'onboarding_reviewing') return 'label-info'
      if (status === 'onboarding_completed') return 'label-success'
      return 'label-default'
    },
    goDetail: function (id) {
      this.$router.push({ path: '/onboarding/' + id })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/onboarding-list.js